// extracted by mini-css-extract-plugin
module.exports = {"altHero":"Vi","altProd":"Wi","subheading":"Xi","subtext":"Yi","extrainfo":"Zi","copy":"_i","cta":"aj","disabled":"bj"};